export default {
  title: 'Ten krok obsługuje Twój dostawca',
  description: {
    payments: 'Skontaktuj się z {{partner}}, aby skonfigurować płatności online.',
    go_live: 'Skontaktuj się z {{partner}}, aby uruchomić swoją restaurację.',
  },
  fallback_partner: 'Twój dostawca',
};
